<template>
  <div class="wizard-lineal" v-if="canViewScreen">
    <v-stepper v-model="step" non-linear>
      <v-stepper-header>
        <v-stepper-step v-if="esWizardJugadores" editable step="1">
          Seleccionar jugador original
        </v-stepper-step>
        <v-stepper-step v-else editable step="1">
          Seleccionar personal original
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step v-if="esWizardJugadores" editable step="2">
          Seleccionar jugador duplicado
        </v-stepper-step>
        <v-stepper-step v-else editable step="2">
          Seleccionar personal duplicado
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="3" editable>
          Resultado final (Vista previa)
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div>
            <SearchPlayer :esWizardJugadores="esWizardJugadores" :jugadorOriginal="null"
              @update:items="contratosOriginal = $event" @update:personal="jugadorOriginal = $event"
              @update:photoPersonal="photoPersonal = $event">
            </SearchPlayer>
            <v-btn style="margin-top: 20px;" color="primary" @click="step = 2">Siguiente</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2">
          <div>
            <SearchPlayer :esWizardJugadores="esWizardJugadores" :segundaPantalla="true"
              :jugadorOriginal="jugadorOriginal" @update:items="contratosDuplicado = $event"
              @update:personal="jugadorDuplicado = $event">
            </SearchPlayer>
            <v-btn style="margin-top: 20px;" color="primary" @click="step = 3">Siguiente</v-btn>
            <v-btn style="margin-top: 20px;" text @click="step = 1">Atrás</v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="3">
          <div>
            <PlayerFinal :esWizardJugadores="esWizardJugadores" v-if="playerCombinado" :photoPersonal="photoPersonal"
              :playerFinalCombinado="playerCombinado" :contratosFinalCombinado="contratosCombinado">
            </PlayerFinal>
            <v-text v-else>Primero debe seleccionar ambos jugadores</v-text>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
  <div v-else>
    <v-text>No tiene permisos para ver esta sección</v-text>
  </div>
</template>

<script>
import PlayerFinal from '../components/PlayerFinal.vue'
import SearchPlayer from '../components/SearchPlayer.vue'

export default {
  components: {
    SearchPlayer,
    PlayerFinal
  },
  data () {
    return {
      esRutaJugador: Boolean,
      step: 1,
      path: 'players',
      filterPath: 'filters/players',
      jugadorOriginal: null,
      photoPersonal: '',
      contratosOriginal: {
        type: Array,
        default: () => []
      },
      jugadorDuplicado: null,
      contratosDuplicado: {
        type: Array,
        default: () => []
      },
      playerCombinado: null,
      contratosCombinados: {
        type: Array,
        default: () => []
      }
    }
  },
  watch: {
    contratosOriginal: {
      handler (newVal) {
        if (newVal) {
          // hacer algo con contratco original
        }
      },
      deep: true,
      immediate: true
    },
    contratosDuplicado: {
      handler (newVal) {
        if (newVal) {
          if (this.contratosOriginal.length > 0) {
            // agregamos jugador a cada array
            const originales = this.contratosOriginal.map(c => ({ ...c, jugador: 'Original' }))
            const duplicados = this.contratosDuplicado.map(c => ({ ...c, jugador: 'Duplicado' }))

            // combinamos ambos arrays
            this.contratosCombinado = originales.concat(duplicados)
          }
        }
      },
      deep: true,
      immediate: true
    },
    jugadorOriginal: {
      handler (newVal) {
        if (newVal) {
        }
      },
      deep: true,
      immediate: true
    },
    jugadorDuplicado: {
      handler (newVal) {
        if (newVal && this.jugadorOriginal) {
          let combinado = { ...this.jugadorOriginal }

          combinado.player = {
            ...this.jugadorOriginal.player,
            originalPk: this.jugadorOriginal.player.pk,
            duplicatedPk: newVal.player.pk
          }

          if (!combinado.player.dni && newVal.player.dni) {
            combinado.player.dni = newVal.player.dni
          }

          if (!combinado.player.pasaporte && newVal.player.pasaporte) {
            combinado.player.pasaporte = newVal.player.pasaporte
          }

          this.playerCombinado = combinado
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    esWizardJugadores () {
      return this.$route.name === 'wizard-jug-dup'
    },
    esWizardCuerpoTecnico () {
      return this.$route.name === 'wizard-tec-dup'
    },
    canViewScreen () {
      return this.$store.state.permissions.canViewJugadoresDuplicados
    }
  }

}
</script>
